"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCommentContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledCommentContainer = styled_components_1.default.div `
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.text.secondary};
  gap: ${({ theme }) => theme.spacing(1)};

  .MuiButtonBase-root {
    padding: 0;
  }
`;
